<script setup lang="ts">
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { computed } from 'vue';
// import { useUserStore } from '@/stores/useUserStore';
import AvatarCross from '@/assets/icons/Avatars/AvatarCross.vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  'update:visible': [value: boolean];
}>();

const { t } = useI18n();
const router = useRouter();
// const userStore = useUserStore();

const localVisible = computed({
  get: () => props.visible,
  set: (value: boolean) => emit('update:visible', value),
});

// const currentPlan = computed(() => {
//   return userStore.subscriptionStatus?.plan_name || 'Freemium';
// });

// const handleAcknowledge = async () => {
//   await userStore.acknowledgeTrialEnd();
//   localVisible.value = false;
// };

const goToSubscription = async () => {
  // await userStore.acknowledgeTrialEnd();
  localVisible.value = false;
  router.push({ name: 'subscription-plans' });
};

const goToProfile = async () => {
  localVisible.value = false;
  router.push({ name: 'profile' });
};
</script>

<template>
  <Dialog v-model:visible="localVisible" modal :style="{ width: '90vw', maxWidth: '400px' }" :closable="false">
    <template #header>
      <div class="flex items-center gap-2">
        <i class="pi pi-info-circle text-xl text-blue-500"></i>
        <span class="font-semibold">{{ t('subscription.trial.trialEnded') }}</span>
      </div>
    </template>

    <AvatarCross class="mx-auto my-4 w-32" />

    <div class="space-y-4">
      <p class="text-gray-700">
        {{ t('subscription.trial.trialEndedMessage') }}
      </p>

      <!-- <div class="bg-orange-50 p-3 rounded-lg">
        <p class="text-sm text-orange-800">
          {{ $t('subscription.trial.upgrade_prompt') }}
          <router-link to="/subscription" class="font-medium underline">
            {{ $t('subscription.upgrade_plan') }}
          </router-link>
        </p>
      </div> -->
    </div>

    <template #footer>
      <div class="flex w-full items-center justify-center gap-2">
        <Button :label="t('subscription.seeSubscriptions')" outlined @click="goToSubscription" />
        <Button :label="t('profile.label')" outlined @click="goToProfile" />
        <!-- <Button 
          :label="$t('common.got_it')" 
          @click="handleAcknowledge" 
          class="bg-blue-500 hover:bg-blue-600 text-white px-6"
        /> -->
      </div>
    </template>
  </Dialog>
</template>
